module.exports = "<div class=\"appshell__scope\"> <div class=\"page\"> <page-header page-title=\"{{$ctrl.title}}\"> </page-header> <page-content> <div class=\"page__content appframe\"> <iframe ng-src=\"{{$ctrl.trustedSrc}}\" frameborder=\"0\"/> </div> </page-content> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/appShell/appShell.html
// module id = 1455
// module chunks = 28